<template>

    <div class="wrapper">

        <section class="intro politica column-center">

            <h1 class="big-title column-center">
                <span>Mapa web</span>
            </h1>

        </section>

        
        <section class="breadcrumb">
            <nav class="container row-start">
              <router-link to="/">Home</router-link>
              <a>Mapa web</a>
            </nav>
          </section>
      

        <section class="contenedor-mapa-web">
            <div class="container">
                <nav class="menu-links column-center">
                    <router-link class="big" to="/">Inicio</router-link>
                    <a class="big">Las Experiencias</a>
                    <router-link v-for="(categoria, key) in categorias.filter(e => e.featured == 1 && !e.mother_id)" :key="key" class="sub" :to="$t('enlaces.categoria')+'/'+categoria.slug">{{categoria.name}}</router-link>
                    
                    <router-link class="big" :to="$t('enlaces.como_inscribirte')">¿Cómo inscribirte?</router-link>
                    <router-link class="big" :to="$t('enlaces.buscador')">Buscador</router-link>
                  </nav>
            </div>
        </section>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'mapa-web',
        computed: {
            ...mapGetters({
                categorias: 'getCategorias'
            })
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/views/mapa-web.vue